<template>
    <div v-if="status == 5">
        <Alert type="info">
            <span>
                A nota está sendo <b>processada</b>. O retorno pode levar alguns
                minutos,
                <Button :_key="updateButtonKey" title="atualizar" type="info" classIcon="fa-solid fa-arrows-rotate"
                    size="small" :clicked="update" />
            </span>
        </Alert>
    </div>
</template>
<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";

import { mapMutations, mapGetters } from "vuex";

export default {
    name: "NfseEmProcessamento",
    props: {
        status: {
            type: Number,
            default: 0,
        },
        updateButtonKey: {
            type: String,
            default: "btnUpdateNfse",
        }
    },
    components: {
        Alert, Button
    },
    methods: {
        ...mapMutations("generic", ["addEvent"]),
        update() {
            this.addEvent({ name: "updateNfse" });
        }
    },
    computed: {
        ...mapGetters("generic", ["showModal"]),
    },
}
</script>
<style scoped>
.nfse-link {
    cursor: pointer;
}
</style>
